/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniChevronDoubleRight = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-chevron-double-right ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M4.23017 13.7094C3.93159 13.9965 3.92228 14.4713 4.20938 14.7698C4.49647 15.0684 4.97125 15.0777 5.26983 14.7906L9.76983 10.5406C9.91689 10.3992 10 10.204 10 10C10 9.79599 9.91689 9.60078 9.76983 9.45938L5.26983 5.20938C4.97125 4.92228 4.49647 4.93159 4.20938 5.23017C3.92228 5.52875 3.93159 6.00353 4.23017 6.29063L8.16792 10L4.23017 13.7094Z"
        fill="#7041F1"
      />
      <path
        className="path"
        d="M10.2302 13.7094C9.93159 13.9965 9.92228 14.4713 10.2094 14.7698C10.4965 15.0684 10.9713 15.0777 11.2698 14.7906L15.7698 10.5406C15.9169 10.3992 16 10.204 16 10C16 9.79599 15.9169 9.60078 15.7698 9.45938L11.2698 5.20938C10.9713 4.92228 10.4965 4.93159 10.2094 5.23017C9.92228 5.52875 9.93159 6.00353 10.2302 6.29063L14.1679 10L10.2302 13.7094Z"
        fill="#7041F1"
      />
    </svg>
  );
};
